import React, { useEffect, useState } from "react";
import { X, Share, Plus } from "lucide-react";

const IOSInstallPrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if device is iOS
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

    // Check if app is already installed (standalone mode)
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone;

    // Check if user has dismissed the prompt before
    const hasSeenPrompt = localStorage.getItem("iosInstallPromptDismissed");

    // Show prompt if: iOS device, not in standalone, hasn't seen prompt, and not dismissed within 7 days
    if (isIOS && !isStandalone && !hasSeenPrompt) {
      // Show prompt after 3 seconds
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 3000);

      return () => clearTimeout(timer);
    } else if (hasSeenPrompt) {
      // Check if 7 days have passed since dismissal
      const dismissedTime = parseInt(hasSeenPrompt, 10);
      const sevenDays = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

      if (Date.now() - dismissedTime > sevenDays) {
        localStorage.removeItem("iosInstallPromptDismissed");
      }
    }
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem("iosInstallPromptDismissed", Date.now().toString());
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg animate-slide-up">
      <div className="max-w-md mx-auto">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center">
            <img
              src="/AppImages/ios/180.png"
              alt="ATIAM COLLEGE"
              className="w-12 h-12 rounded-lg mr-3"
            />
            <div>
              <h3 className="font-semibold text-gray-900">
                Install ATIAM COLLEGE
              </h3>
              <p className="text-sm text-gray-600">
                Add to Home Screen for quick access
              </p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Dismiss"
          >
            <X size={20} />
          </button>
        </div>

        <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 mb-3">
          <p className="text-sm text-gray-700 mb-2 font-medium">
            How to install:
          </p>
          <ol className="text-sm text-gray-600 space-y-2">
            <li className="flex items-start">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center mr-2 mt-0.5">
                1
              </span>
              <span>
                Tap the <Share size={14} className="inline mx-1" /> Share button
                at the bottom of Safari
              </span>
            </li>
            <li className="flex items-start">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center mr-2 mt-0.5">
                2
              </span>
              <span>
                Scroll down and tap <Plus size={14} className="inline mx-1" />{" "}
                "Add to Home Screen"
              </span>
            </li>
            <li className="flex items-start">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center mr-2 mt-0.5">
                3
              </span>
              <span>Tap "Add" in the top right corner</span>
            </li>
          </ol>
        </div>

        <div className="flex items-center justify-center text-xs text-gray-500">
          <Share size={12} className="mr-1" />
          <span>Works only in Safari browser</span>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallPrompt;
